import { createI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '../utils/constants';
import zhCN from '../locales/zh-CN.yaml';
import enUS from '../locales/en-US.yaml';

export const createAppI18n = (language = DEFAULT_LANGUAGE) => createI18n({
  locale: language,
  fallbackLocale: {
    'en-US': [DEFAULT_LANGUAGE],
  },
  legacy: false,
  allowComposition: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
});

export type I18n = ReturnType<typeof createAppI18n>;
